import React, { useEffect, useState } from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    Pagination,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import { EditOutlined, DeleteOutline } from "@mui/icons-material";
import { collection, getDocs, doc, setDoc, deleteDoc, Timestamp } from "firebase/firestore";
import Swal from "sweetalert2";
import { db } from "../../firebase";

const PAGE_SIZE = 10;

function Incomeheads() {
    const [IncomeHeads, setIncomeHeads] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");

    const [form, setForm] = useState({
        name: "",
        payMode: "",
    });

    const [openDialog, setOpenDialog] = useState(false);

    // ================= Load Income heads =================
    useEffect(() => {
        loadIncomeHeads();
    }, []);

    const loadIncomeHeads = async () => {
        const snap = await getDocs(collection(db, "incomeHeads"));
        const arr = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setIncomeHeads(arr);
    };

    // ================= Form change handler =================
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    // ================= Save / Update =================
    const saveIncomeHead = async () => {
        if (!form.name ) {
            Swal.fire("Error", "Please fill all required fields", "error");
            return;
        }

        try {
            const id = editingId || doc(collection(db, "incomeHeads")).id;
            await setDoc(doc(db, "incomeHeads", id), {
                ...form,
                createdTime: editingId ? form.createdTime : Timestamp.now(),
            });

            Swal.fire("Success", editingId ? "Income head updated" : "Income head added", "success");

            setForm({ name: "", payMode: "" });
            setEditingId(null);
            setOpenDialog(false);
            loadIncomeHeads();
        } catch (error) {
            Swal.fire("Error", error.message, "error");
        }
    };

    // ================= Edit =================
    const editIncomeHead = (head) => {
        setForm(head);
        setEditingId(head.id);
        setOpenDialog(true);
    };

    // ================= Delete =================
    const deleteIncomeHead = async (id) => {
        const res = await Swal.fire({
            title: "Delete Income head?",
            icon: "warning",
            showCancelButton: true,
        });

        if (!res.isConfirmed) return;

        await deleteDoc(doc(db, "incomeHeads", id));
        Swal.fire("Deleted", "Income head removed", "success");
        loadIncomeHeads();
    };

    // ================= Filter & Pagination =================
    const filtered = IncomeHeads.filter(
        (h) =>
            h.name?.toLowerCase().includes(search.toLowerCase()) ||
            h.payMode?.toLowerCase().includes(search.toLowerCase())
    );
    const paginated = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

    return (
        <Box minHeight="100vh" bgcolor="#f4f6f8">
            <Box flex={1} p={1}>

                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h5" fontWeight={800}>
                        Income Heads Management
                    </Typography>
                    <Button variant="contained" onClick={() => setOpenDialog(true)}>
                        Add New Income Head
                    </Button>
                </Box>

                {/* ================= Search ================= */}
                <TextField
                    label="Search by name or pay mode"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    sx={{ mb: 2, width: "100%" }}
                    size="small"
                />

                {/* ================= Table ================= */}
                <Card>
                    <CardContent>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Sr No</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell align="center">Actions</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {paginated.map((head, index) => (
                                    <TableRow key={head.id}>
                                        <TableCell>{(page - 1) * PAGE_SIZE + index + 1}</TableCell>
                                        <TableCell>{head.name}</TableCell>
                                        <TableCell align="center">
                                            <IconButton color="primary" onClick={() => editIncomeHead(head)}>
                                                <EditOutlined />
                                            </IconButton>
                                            <IconButton color="error" onClick={() => deleteIncomeHead(head.id)}>
                                                <DeleteOutline />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>

                        <Box display="flex" justifyContent="center" mt={2}>
                            <Pagination
                                count={Math.ceil(filtered.length / PAGE_SIZE)}
                                page={page}
                                onChange={(e, v) => setPage(v)}
                            />
                        </Box>
                    </CardContent>
                </Card>

                {/* ================= Add / Edit Dialog ================= */}
                <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                    <DialogTitle>{editingId ? "Edit Income Head" : "Add Income Head"}</DialogTitle>
                    <DialogContent>
                        <Box mt={1} display="flex" flexDirection="column" gap={2}>
                            <TextField
                                label="Name"
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                fullWidth
                                required
                            />

                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                        <Button variant="contained" onClick={saveIncomeHead}>
                            {editingId ? "Update" : "Add"}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </Box>
    );
}

export default Incomeheads;